/* eslint-disable */
export const list = state => state.list;
export const summary = state => state.summary;
export const categoriesList = state => state.categoriesList;
export const getCep = state => state.getCep;
export const partner = state => state.partner;
export const actived = state => state.actived;
export const isLoad = state => state.isLoad;
export const loadingData = state => state.loadingData;
export const activeNew = state => state.activeNew;
export const toggleTaxForm = state => state.toggleTaxForm;
export const account = state => state.account;
export const showError = state => state.showError;
export const errors = state => state.errors;
export const showSuccess = state => state.showSuccess;
export const showConfirm = state => state.showConfirm;
export const showCancel = state => state.showCancel;
export const showSubmit = state => state.showSubmit;
export const showFilters = state => state.showFilters;
export const filtersAccountType = state => state.filtersAccountType;
export const filtersPartner = state => state.filtersPartner;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const page = state => state.page;
export const filtersFinalDate = state => state.filtersFinalDate;
export const filtersPaymentInitialDate = state => state.filtersPaymentInitialDate;
export const filtersPaymentFinalDate = state => state.filtersPaymentFinalDate;
export const filtersCardBrand = state => state.filtersCardBrand;
export const filtersTerminalNumber = state => state.filtersTerminalNumber;
export const filtersOperation = state => state.filtersOperation;
export const filtersOrdination = state => state.filtersOrdination;
export const filtersStatus = state => state.filtersStatus;
export const totalResources = state => state.totalResources;

export const filterStatus = state => state.filterStatus;
export const filtersName = state => state.filtersName;

export const filterParams = state => state.filterParams;

export const pagination = state => {
  const page_set = {
    page: state.page,
    rowsPerPage: state.limit,
    totalItems: state.totalResources
  };
  return page_set;
};

export const filterExportReport = state => {
  const filters = {
    page: state.page || 1,
    limit: state.limit || 10,
    limitOptions: state.limitOptions,
    filterrific: {
      with_created_at_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      sorted_by: state.filtersOrdination,
      with_name: state.filtersName,
      account_type: state.filtersAccountType,
      with_partner: state.filtersPartner
    }
  };
  return filters;
};
